export const PROBLEM_REPORT_FLAG = 'in-app-problem-report';

export type ProblemReportSource = 'sidebar' | 'avatar-menu' | 'mobile-nav';

type Listener = (source: ProblemReportSource) => void;

const listeners = new Set<Listener>();

export function emitOpenProblemReport(source: ProblemReportSource) {
  for (const listener of listeners) listener(source);
}

export function subscribeOpenProblemReport(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
